import { Routes } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { CustomerSuccessAdminTabRoutes } from './customer-success-admin-tab-routes';

export const CustomerSuccessAdminRoutes: Routes = [
  {
    path: 'customer-success-admin',
    canActivate: [LoginGuard],
    loadComponent: () =>
      import('./pages/customer-success-admin/customer-success-admin.component').then(
        (m) => m.CustomerSuccessAdminComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      ...CustomerSuccessAdminTabRoutes,
    ],
  },
];
